import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  coachingService: service(),
  router: service(),

  queryParams: {
    notComplete: {},
  },

  model(params) {
    let individual = this.modelFor('coaching.individuals.individual').record;
    if (get(individual, 'filledOut')) {
      let recentReport = get(individual, 'sortedReports.lastObject');
      // create the first report if one doesn't exist
      if (recentReport == null) {
        let firstReport = this.coachingService.addReport(individual);
        return firstReport.save().then(() => {
          return {
            notComplete: params.notComplete,
          };
        });
      }
    }
    return {
      notComplete: params.notComplete,
    };
  },

  redirect() {
    let individual = this.modelFor('coaching.individuals.individual').record;
    if (get(individual, 'filledOut')) {
      let lastReport = get(individual, 'sortedReports.lastObject');
      if (lastReport != null) {
        this.router.transitionTo(
          'coaching.individuals.individual.report',
          get(lastReport, 'id'),
        );
      }
    } else {
      this.router.transitionTo(
        'coaching.individuals.individual.edit',
        get(individual, 'id'),
      );
    }
  },
});
